<template>
  <div class='opera-bookpage'>
    <topNav :title="title"></topNav>
    <div class="tabs">
      <div class="tab" @click="showPage(1)" :class="{active:pageIndex==1}">
        <span>{{$t('book_active1')}}</span>
      </div>
      <div class="tab" @click="showPage(2)" :class="{active:pageIndex==2}">
        <span>{{$t('book_active2')}}</span>
      </div>
      <div class="tab" @click="showPage(3)" :class="{active:pageIndex==3}">
        <span>{{$t('book_active3')}}</span>
      </div>
      <div class="tab" @click="showPage(4)" :class="{active:pageIndex==4}">
        <span>{{$t('book_active4')}}</span>
      </div>
      <div class="tab" @click="showPage(5)" :class="{active:pageIndex==5}">
        <span>{{$t('book_active5')}}</span>
      </div>
    </div>
    <div class="content">
      <div class="form ">
        <div class="info" v-if="pageIndex==5">
          <label>{{$t('book_name5')}}</label>
          <popSearch ref='input' :debounce='1000' :title='$t("pop_search_A_placeHolder")' :searchPlaceholder='$t("pop_search_A_SearchplaceHolder")' anchor='name'
                     :on-select='onSelect' :get-data="getData"></popSearch>
        </div>
        <div class="info" v-if="pageIndex==4">
          <label>{{$t('book_active4')}}</label>
          <popSearch ref='input' :debounce='1000' :title='$t("book_name4")' :searchPlaceholder='$t("pop_search_S_SearchplaceHolder")' anchor='name'
                     :on-select='onSelect' :get-data="getData"></popSearch>
        </div>
        <div class="info" v-if="pageIndex==3">
          <label>{{$t('book_active3')}}</label>
          <popSearch ref='input' :debounce='1000' :title='$t("pop_search_C_placeHolder")' :searchPlaceholder='$t("pop_search_C_SearchplaceHolder")' anchor='name'
                     :on-select='onSelect' :get-data="getData"></popSearch>
        </div>
        <div class="info" v-if="pageIndex==2">
          <label>{{$t('book_name2')}}</label>
          <popSearch ref='input' :debounce='1000' :title='$t("pop_search_mem_placeHolder")' :searchPlaceholder='$t("pop_search_mem_SearchplaceHolder")' anchor='cardNo'
                     :on-select='onSelect' :get-data="getMember">

          </popSearch>

        </div>
        <div class="info" style="position:relative">
          <label>{{$t('book_rsvMan')}}</label> <input @focus='getFocus()' class="" type="text" class="info-input"
                                   :placeholder="$t('book_rsvMan_placeholder')" maxlength="64" v-model='bookInfo.rsvMan'>
          <i class="iconfont icon-saoma" @click="sfzRe" style="position: absolute;right:0.42rem;color:#999"
             v-if="sfzR"></i>
        </div>
        <div class="info">
          <label>{{$t('book_mobile')}}</label> <input @focus='getFocus()' type="text" class="info-input" :placeholder="$t('book_mobile_placeholder')"
                                   maxlength="11" v-model='bookInfo.mobile'>
        </div>
        <div class="info">
          <label>{{$t('book_idCode')}}</label>
          <div class="parent" :class="{focus:selectedInput=='idCode'&&this.show4==true}">
            <input type="text" class="info-input" name="" v-model='inputVal.idCode' readonly="readonly"
                   @touchstart="showPicker('idCode')">
            <i class="iconfont icon-xia" @touchstart="showPicker('idCode')"></i>
          </div>
        </div>
        <div class="info">
          <label>{{$t('book_idNo')}}</label> <input type="text" class="info-input" :placeholder="$t('book_idNo_placeholder')" v-model='bookInfo.idNo'>
        </div>
        <div class="info">
          <label>{{$t('operaBook_checkin_time')}}</label>
          <div class="parent">
            <div @click="openPick('picker')">{{datetime.startTime.time | fdate}}</div>
            <mt-datetime-picker ref="picker" type="date" @confirm="handleConfirm" :startDate="datetime.minDate"
                                :endDate="datetime.maxDate" v-model="datetime.startTime.time"></mt-datetime-picker>
          </div>
        </div>
        <div class="info">
          <label>{{$t('operaBook_leave_time')}}</label>
          <div class="parent">
            <div @click="openPick('picker2')">{{datetime.endTime.time | fdate}}</div>
            <mt-datetime-picker ref="picker2" type="date" :startDate="datetime.minDate2" :endDate="datetime.maxDate"
                                v-model="datetime.endTime.time"></mt-datetime-picker>
          </div>
        </div>
        <div class="info" v-if="isBook">
          <label>{{$t('book_rmnum')}}</label>
          <div class="parent" :class="{focus:selectedInput=='rmnum'&&this.show4==true}">
            <input type="text" class="info-input" v-model='inputVal.rmnum' @touchstart="showPicker('rmnum')"
                   readonly="readonly">
            <i class="iconfont icon-xia" @touchstart="showPicker('rmnum')"></i>
          </div>
        </div>

        <div class="info" v-else>
          <label>{{$t('book_rmno')}}</label>
          <div class="parent">
            <input type="text" class="info-input" @focus='getFocus()' v-model='bookInfo.rmno' style="color:#F69C2D"
                   readonly="readonly">
          </div>
        </div>
        <div class="info" v-if="isBook">
          <label>{{$t('book_rmtype')}}</label>
          <div class="parent" :class="{focus:this.selectedInput=='rmtype'&&this.show4==true}">
            <input type="text" class="info-input" name="" v-model='inputVal.rmtype' @touchstart="showPicker('rmtype')"
                   readonly="readonly">
            <i class="iconfont icon-xia" @touchstart="showPicker('rmtype')"></i>
          </div>
        </div>

        <div class="info" v-else>
          <label>{{$t('fangXQ_rmtype')}}</label>
          <div class="parent" :class="{focus:selectedInput=='rmtype'&&this.show4==true}">
            <input type="text" class="info-input" @focus='getFocus()' v-model='bookInfo.rmtype' style="color:#F69C2D"
                   readonly="readonly">
          </div>
        </div>
        <div class="info">
          <label>{{$t('book_ratecode')}}</label>
          <!-- <div class="parent" :class="{focus:this.selectedInput=='ratecode'&&this.show4==true}">
                  <input type="text" v-model='inputVal.ratecode' @click="showPicker('ratecode')" readonly="readonly"  placeholder="可空">
                  <i class="iconfont icon-xia" @click="showPicker('ratecode')"></i>
              </div> -->
          <popSearch ref='rateInput' :debounce='100' :title='$t("book_ratecode")' :searchPlaceholder='$t("operaBook_search_rmno")' anchor='code'
                     :get-data="matchRatecode">
            <ul class="ratelist" slot="list">
              <li v-for="(item,key) in matchCode">
                <div class="code" @click="onSelectRatecode(item.code)">{{item.name}}</div>
              </li>
            </ul>
          </popSearch>
        </div>
        <p class="tip">{{$t('book_firstDayMoney')}}:{{everyDayRate.firstDayMoney}}</p>
        <div class="info">
          <label>{{$t('book_remark')}}</label>
          <textarea class="remark" v-model="bookInfo.remark" :placeholder="$t('placeHolder_Empty')"></textarea>
        </div>
      </div>
    </div>
    <div class="foot">
      <div class="amount" @touchstart="show_mx">{{$t('book_amount')}}:
        <span>￥{{everyDayRate.totalMoney||0}}</span>
        <i id="mx_angle" class="iconfont icon-xia"></i>
      </div>
      <div class="bookbtn" @click='book'>{{title}}</div>
    </div>
    <!-- 明细弹框 -->
    <mt-popup class="mx_pop" v-model="mx_popupVisible" position="bottom" :modal="false">
      <div class="mx">
        <div class="count">
          <span>{{$t('book_count')}}</span>
          <div class="icon">
            <i class="iconfont icon-cuowu" @touchstart='hide_mx'></i>
          </div>
        </div>
        <ul class="mxList">
          <li class="list" v-for='(item,key) in everyDayRate.list' :key="key">
            <span>{{item.d|dateMD}}</span>
            <span>{{$t('orderFromReport_rev_rm')}}</span>
            <span>￥{{item.privce}} *{{item.count}}</span>
          </li>
          <li class="total">
            <span style="float:left">{{$t('book_total')}}</span>
            <span style="float:right">￥{{everyDayRate.totalMoney||0}}</span>
          </li>

        </ul>
      </div>
    </mt-popup>
    <!-- picker弹框 -->
    <div class="pickerBox">
      <vue-pickers :show="show4" :selectData="optionSlot" v-on:cancel="close" v-on:confirm="confirmFn"></vue-pickers>
    </div>
  </div>
</template>

<script>
  // import VeeValidate, { Validator } from 'vee-validate';
  import {Toast, Picker} from "mint-ui";
  import moment from "moment";
  import popSearch from "../operaCommon/popSearch";
  // import inputPop from "../common/inputPop";
  import VuePickers from "vue-pickers";

  export default {
    data() {
      return {
        popupVisible: false,
        /*日历信息*/
        datetime: {
          startTime: {
            time: this.$route.query.date || moment().format("YYYY-MM-DD")
          },
          endTime: {
            time:
              this.$route.query.enddate ||
              moment()
                .add(1, "d")
                .format("YYYY-MM-DD")
          },
          minDate: moment().toDate(),
          minDate2: moment(
            moment()
              .add(1, "d")
              .format("YYYY-MM-DD")
          ).toDate(),
          maxDate: moment(
            moment()
              .add(6, "M")
              .format("YYYY-MM-DD")
          ).toDate()
        },

        mx_popupVisible: false,
        popupVisible: false,
        pageIndex: 1, //tab切换页面
        optionSlot: {
          columns: 1,
          pData1: [
            {
              text: [],
              value: []
            }
          ]
        }, //pop数据对象
        options: {
          //pop配置项
          salesman: {
            columns: 1,
            pData1: [
              {
                flex: 1,
                defaultIndex: 1,
                // values: [],
                // code: []
                text: [],
                value: []
              }
            ]
          },
          idCode: {
            columns: 1,
            pData1: [
              {
                flex: 1,
                defaultIndex: 1,
                // values: [],
                // code: []
                text: [],
                value: []
              }
            ]
          },
          rmtype: {
            columns: 1,
            pData1: [
              {
                flex: 1,
                defaultIndex: 1,
                // values: [],
                // code: []
                text: [],
                value: [],
                rmnumable: []
              }
            ]
          },
          rmnum: {
            columns: 1,
            pData1: [
              {flex: 1, defaultIndex: 1, text: 1, value: 1},
              {flex: 1, defaultIndex: 1, text: 2, value: 2},
              {flex: 1, defaultIndex: 1, text: 3, value: 3},
              {flex: 1, defaultIndex: 1, text: 4, value: 4},
              {flex: 1, defaultIndex: 1, text: 5, value: 5},
              {flex: 1, defaultIndex: 1, text: 6, value: 6},
              {flex: 1, defaultIndex: 1, text: 7, value: 7},
              {flex: 1, defaultIndex: 1, text: 8, value: 8},
              {flex: 1, defaultIndex: 1, text: 9, value: 9},
              {flex: 1, defaultIndex: 1, text: 10, value: 10}
            ]
          },
          ratecode: {
            columns: 1,
            pData1: [
              {
                flex: 1,
                defaultIndex: 1,
                // values: [],
                // code: []
                text: [],
                value: []
              }
            ]
          }
        },
        inputVal: {
          idCode: "身份证",
          salesman: "",
          rmtype: "",
          rmnum: 1,
          ratecode: ""
        },
        selectedInput: "", //弹框的数值对象
        selectedvalue: "", //备选的值
        selectedcode: "", //备选的code
        //   dataIndex: 0, //数据条数
        bookInfo: {
          //预定信息
          arr: "", //入住时间（非空）
          cardNo: "", //	卡号（可空，类型为会员时填写）
          dep: "", //离店时间（非空）
          idCode: "", //	证件类型（可空）
          idNo: "", //	证件号（可空）
          mobile: "", //	手机，散客会员时填写，协议公司可空
          ratecode: "", //	价格代码（非空）
          remark: "", //备注（可空）
          rmnum: 1, //房间数（不可空》=1
          rmtype: "", //	房型不可空
          rsvMan: "", //	预订人不可空
          salesman: "", //	销售员，可空
          rmno: "", //房号 可空
          rsvCompanyId: "",
          token: "",
        },
        isBook: true,
        isReserve: true, //是否步入预订
        title: "预订",
        memberInfo: {}, //会员信息
        everyDayRate: {}, //每日房价
        show4: false,
        salesPerson: [], //销售员重组数据
        roomPriceCode: [], //房价码重组数组
        objIdCode: [], //idcode重组
        sfzR: null,
        rateCodeList: [],
        matchCode: [],
      };
    },
    mounted() {
      document.getElementsByClassName("pickerBox")[0].classList.add("noShow");
      this.bookInfo.rmtype = this.$route.query.rmtype;
      this.bookInfo.rmno = this.$route.query.rmno;
      this.isBook = this.$route.query.rmno == null;
      this.isReserve =
        this.$route.query.isReserve == null || this.$route.query.isReserve;
      this.title = this.isReserve ? "预订" : "入住";
      this.getOrderInit(1); //获取房型

      this.$http
        .get("/mobilepmsapi/opera/biz/pmsPrarms?", {params: {type: "ID_CODES"}})
        .then(res => {
          res.data.retVal.forEach((val, key, arr) => {
            this.objIdCode.push({
              text: arr[key].name,
              value: arr[key].code
            });
          });
          this.options.idCode.pData1 = this.objIdCode;
          // console.log('证件类型：'+JSON.stringify( this.objIdCode))
          for (var i = 0, len = this.objIdCode.length; i < len; i++) {
            if (this.objIdCode[i].text == "身份证") {
              this.bookInfo.idCode = this.objIdCode[i].value;
            }
          }
        });
    },
    methods: {
      //匹配房价码
      matchRatecode(code) {
        let count = 0
        let codeUp = !code ? "" : code.toUpperCase();

        let mk = [];
        for (let i = 0; i < this.rateCodeList.length; i++) {
          var item = this.rateCodeList[i];

          if (!codeUp || item.code.toUpperCase().indexOf(codeUp) >= 0) {
            count++;
            mk.push(item);
            if (count > 15) {
              break;
            }
          }
        }
        this.matchCode = mk;
        this.$refs.rateInput.showList = this.matchCode.length > 0 ? true : false
      },
      //选定房价码
      onSelectRatecode(val) {
        // this.inputVal.ratecode = val
        this.bookInfo.ratecode = val;
        this.$refs.rateInput.popupVisible = false
        this.$refs.rateInput.backUpValue = val

      },
      getFocus() {
        this.show4 = false;
      },
      /*获取每日房价*/
      getEverydayRate() {
        if (
          this.datetime.endTime.time &&
          this.datetime.startTime.time &&
          this.bookInfo.ratecode &&
          this.bookInfo.rmnum &&
          this.bookInfo.rmtype &&
          moment(this.datetime.startTime.time) <= moment(this.datetime.endTime.time)
        ) {
          this.$http
            .post("/mobilepmsapi/opera/biz/rateQueryEveryDay", {
              end: moment(this.datetime.endTime.time).format("YYYY-MM-DD"),
              start: moment(this.datetime.startTime.time).format("YYYY-MM-DD"),
              ratecode: this.bookInfo.ratecode,
              rmnum: this.bookInfo.rmnum,
              rmtype: this.bookInfo.rmtype
            })
            .then(res => {
              if (res.data.result == 0) {
                this.everyDayRate = res.data.retVal;
                //   console.log('房型和价钱：'+this.everyDayRate)
              } else {
                Toast({
                  message: res.data.msg,
                  position: "bottom",
                  duration: 1000
                });
              }
            });
        }
      },
      sfzRe() {
        var A = plus.webview.getLaunchWebview();
        var that = this;
        window.sfzback = function (a) {
          //alert(a);
          var so = JSON.parse(a);
          if (so.error_code != 0) {
            that.msg(this.$t('msg_sfzRe'))
          } else {
            that.bookInfo.rsvMan = so.name;
            that.bookInfo.idCode = "01";
            that.bookInfo.idNo = so.id_number;
            that.bookInfo.address = so.address;
            that.bookInfo.sex = so.sex;
            that.bookInfo.birthday = so.birthday;
            that.bookInfo.national = so.people;
          }
        };
        A.evalJS("getSFZ('" + that.sfzR + "')");
      },
      //入住时间和离店时间的弹框打开
      openPick(p) {
        this.$refs[p].open();
        this.show4 = false;
      },
      //入住时间和离店时间弹窗的确认键
      handleConfirm(d) {
        this.minDate2 = moment(this.datetime.startTime.time)
          .add(1, "d")
          .toDate();
        if (moment(this.datetime.endTime.time) < moment(this.datetime.startTime.time)) {
          this.datetime.endTime.time = moment(this.datetime.startTime.time)
            .add(1, "d")
            .format("YYYY-MM-DD");
        }
      },
      /*选定inputSearchText的值*/
      onSelect(value) {
        //console.log('搜索的value' + JSON.stringify(value))
        if (this.pageIndex == 2) {
          this.bookInfo.rsvMan = value.name;
          this.bookInfo.mobile = value.mobile;
          this.inputVal.mobile = value.mobile;
          this.bookInfo.cardNo = value.cardNo;
          this.inputVal.cardNo = value.cardNo;
          this.bookInfo.email = value.email;
          this.inputVal.email = value.email;
          this.bookInfo.cardType = value.cardType;
          this.inputVal.cardType = value.cardType;
          if (value.idNo != null && value.idNo != "") {
            this.bookInfo.idNo = value.idNo;
          }
          if (value.idType != null && value.idType != "") {
            this.bookInfo.idCode = value.idType;
          }

          if (!this.isBook) {
            //取默认证件类型
            if (value.idType != null && value.idType != "") {
              for (var i = 0, len = this.objIdCode.length; i < len; i++) {
                if (this.objIdCode[i].value == value.idType) {
                  this.inputVal.idCode = this.objIdCode[i].text;
                  this.bookInfo.idCode = this.objIdCode[i].value;
                  break;
                }
              }
            }
          }
        } else {
          this.bookInfo.rsvCompanyId = value.id;
          // if (value.rateCode) {
          //     this.bookInfo.ratecode = value.rateCode;
          //     this.inputVal.ratecode = value.rateCode;
          // }
          if (value.saleman != null && value.saleman != "") {
            this.bookInfo.salesman = value.saleman;
            this.inputVal.salesman = value.salemanDis; //取传回来的销售员中文字段显示
            //   console.log('搜索框value.saleman'+JSON.stringify(value.saleman))
            for (var i = 0; i < this.options.salesman[0].pData1.length; i++) {
              if (this.options.salesman[0].pData1[i].value == value.saleman) {
                this.inputVal.salesman = this.options.salesman[0].pData1[i].text;
                this.bookInfo.salesman = this.options.salesman[0].pData1[i].value;
                break;
              }
            }
          }
        }
        // console.log(this.bookInfo.rmtype)
        this.getEverydayRate();
      },
      /*协议公司/旅行社/中介searchText*/
      async getData(value) {
        if (value != null && value != "") {
          var stat = "";
          if (this.pageIndex == 3) {
            this.stat = "C";
          } else {
            this.stat = this.pageIndex == 4 ? "S" : "A";
          }
          await this.$http
            .post("/mobilepmsapi/opera/biz/compnaySearch", {
              pageSize: 10,
              searchText: value,
              sysCat: this.stat
            })
            .then(res => {
              if (res.data.result == 0) {
                if (res.data.retVal.length > 0) {
                  this.$refs.input.showList = true
                  this.$refs.input.json = res.data.retVal;
                } else {
                  this.$refs.input.showList = false
                }
              } else {
                this.$refs.input.showList = false
                //  Toast({
                //         className: "msgclass",
                //         message: res.msg,
                //         position: "middle",
                //         duration: 3000
                //     });
              }
            });
        }
      },
      /*获取会员信息 searchText*/
      getMember(value) {
        this.$http
          .post("/mobilepmsapi/opera/biz/memberSearch", {con: value})
          .then(res => {
            if (res.data.result == 0) {
              if (res.data.retVal.length > 0) {
                this.$refs.input.showList = true
                this.$refs.input.json = res.data.retVal;
              } else {
                this.$refs.input.showList = false
              }
            } else {
              this.$refs.input.showList = false
            }
            //   console.log('会员的数据'+JSON.stringify(res.data.retVal) )
          }).catch(err => {
          this.$refs.input.showList = false
        });
      },
      /*预定初始化信息 每次切换房间数量更新*/
      getOrderInit(value) {
        this.$http
          .post("/mobilepmsapi/opera/biz/bookInit", {
            arr: "",
            dep: "",
            rmnum: value || 1
          })
          .then(res => {
            this.options.rmtype.pData1 = [];

            this.sfzR = res.data.retVal.sfzR;
            this.bookInfo.token = res.data.retVal.token;
            //获取房型
            res.data.retVal.list.forEach((val, key, arr) => {
              let objroom = {};
              if (!val.canBook) {
                objroom.text = arr[key].descript + this.$t('book_disRmType_des');
                objroom.value = arr[key].rmtype;
              } else {
                objroom.text = arr[key].descript;
                objroom.value = arr[key].rmtype;
              }
              this.options.rmtype.pData1.push(objroom);
            });
            // console.log(this.options.rmtype.pData1)
            // //获取销售员
            // res.data.retVal.saleMan.forEach((val, key, arr) => {
            //   this.salesPerson.push({
            //     text: arr[key].name,
            //     value: arr[key].code
            //   });
            // });
            // this.options.salesman.pData1 = this.salesPerson;
            // console.log("获取销售员" + JSON.stringify(this.salesPerson));

            //获取房价码
            //   res.data.retVal.rateCodeList.forEach((val, key, arr) => {
            //     this.roomPriceCode.push({
            //       text: arr[key].name,
            //       value: arr[key].code
            //     });
            //   });
            //   this.options.ratecode.pData1 = this.roomPriceCode;

            // this.datetime.startTime.time=res.data.retVal.bizDate
            this.initDate(res.data.retVal.bizDate)

            //默认房价码
            this.bookInfo.ratecode = res.data.retVal.defaultRateCode;
            this.$refs.rateInput.backUpValue = res.data.retVal.defaultRateCode;
            this.rateCodeList = res.data.retVal.rateCodeList//房价码列表
            this.matchCode = this.rateCodeList.slice(0, 15)//默认前15个展示
            this.getEverydayRate();
          });
      },
      initDate(bizdate) {
        this.datetime.startTime.time = moment(bizdate).format("YYYY-MM-DD")
        this.datetime.endTime.time = moment(bizdate).add(1, "d").format("YYYY-MM-DD")
        this.datetime.minDate = moment(moment(bizdate).format("YYYY-MM-DD")).toDate()
        this.datetime.minDate2 = moment(moment(bizdate).add(1, "d").format("YYYY-MM-DD")).toDate()
        this.datetime.maxDate = moment(moment(bizdate).add(6, "M").format("YYYY-MM-DD")).toDate()
        // console.log(this.datetime.endTime.time)
      },
      //底部隐藏费用明细
      hide_mx() {
        this.mx_popupVisible = false;
        document.getElementById("mx_angle").style.transform = "rotate(0deg)";
      },
      //显示底部费用明细
      show_mx() {
        if (this.mx_popupVisible == true) {
          this.hide_mx();
        } else {
          this.mx_popupVisible = true;
          document.getElementById("mx_angle").style.transform = "rotate(180deg)";
        }
      },
      /*切换tab*/
      showPage(value) {
        if (this.pageIndex != value) {
          this.pageIndex = value;
          if (!!this.$refs.input) {
            //清空searchText
            this.$refs.input.backUpValue = "";
            this.$refs.input.value = "";
            this.$refs.input.json = "";
            //清空上一次在其他tab里选中的会员卡，协议公司和中介
            this.bookInfo.rsvCompanyId = "";
            this.bookInfo.cardNo = "";
          }
          // this.inputVal.ratecode = "";//房价码清空
          // this.bookInfo.ratecode = ""; //房价码清空
          this.getEverydayRate();
        }
      },
      //打开picker下拉插件方法
      showPicker(item) {
        this.show4 = !this.show4;
        if (this.show4 == true) {
          this.optionSlot = this.options[item];
          this.selectedInput = item;
          document
            .getElementsByClassName("pickerBox")[0]
            .classList.remove("noShow");
        }
      },
      //picker插件左侧取消键
      close() {
        this.show4 = false;
        document.getElementsByClassName("pickerBox")[0].classList.add("noShow");
      },
      //picker插件右侧确认键
      confirmFn(data) {
        this.show4 = false;
        document.getElementsByClassName("pickerBox")[0].classList.add("noShow");
        if (_.indexOf(["ratecode", "rmnum", "rmtype"], this.selectedInput) != -1) {
          this.inputVal[this.selectedInput] = data.select1.text;
          this.bookInfo[this.selectedInput] = data.select1.value;
          this.getEverydayRate();
          if (this.selectedInput == "rmnum") {
            this.getOrderInit(data.select1.text);
          }
        } else if (
          _.indexOf(["salesman", "rmtype", "idCode"], this.selectedInput) != -1
        ) {
          this.inputVal[this.selectedInput] = data.select1.text;
          this.bookInfo[this.selectedInput] = data.select1.value;
        } else {
          this.inputVal[this.selectedInput] = data.select1.text;
          this.bookInfo[this.selectedInput] = data.select1.text;
        }
        this.selectedInput = "";
      },
      hide_picker() {
        this.popupVisible = false;
        this.selectedInput = "";
      },
      msg(msg) {
        Toast({
          message: msg,
          position: "bottom",
          duration: 3000
        });
        return false;
      },
      //预定或者入住
      book() {
        if (this.pageIndex == 4) {
          if (_.isEmpty(this.bookInfo.rsvCompanyId)) {
            return this.msg(this.$t('msg_rsvCompanyId4'));
          }
        } else if (this.pageIndex == 3) {
          if (_.isEmpty(this.bookInfo.rsvCompanyId)) {
            return this.msg(this.$t('msg_rsvCompanyId3'));
          }
        } else if (this.pageIndex == 2) {
          if (_.isEmpty(this.bookInfo.cardNo)) {
            return this.msg(this.$t('msg_rsvCompanyId2'));
          }
        }
        if (_.isEmpty(this.bookInfo.rsvMan)) {
          return this.msg(this.$t('msg_rsvMan'));
        }
        if (_.isEmpty(this.bookInfo.rmtype)) {
          return this.msg(this.$t('msg_rmtype'));
        }
        var address = "book";
        if (!this.isBook) {
          if (_.isEmpty(this.bookInfo.idCode)) {
            return this.msg(this.$t('msg_idCode'));
          }
          // if (_.isEmpty(this.bookInfo.idNo)) {
          //   return this.msg("证件号码不能为空");
          // }
          if (this.isReserve) {
            address = "book";
          } else {
            address = "book";
            this.bookInfo.status = 'in'
          }
        }
        this.bookInfo.arr = moment(this.datetime.startTime.time).format("YYYY-MM-DD");
        this.bookInfo.dep = moment(this.datetime.endTime.time).format("YYYY-MM-DD");
        this.bookInfo.type = this.pageIndex;
        this.$http
          .post("/mobilepmsapi/opera/biz/" + address, this.bookInfo)
          .then(res => {
            if (res.data.result == 0) {
              this.msg(this.title + this.$t('success'));
              if (this.isBook) {
                this.$router.push("/opera/orderDetail?rsvNo=" + res.data.retVal.rsvNo);
              } else {
                if (!res.data.retVal.isRoomDetail) {
                  this.$router.push(
                    "/opera/orderDetail?rsvNo=" +
                    res.data.retVal.rsvNo +
                    "&redirect=/opera/fangT"
                  );
                } else if (this.isReserve) {
                  this.$router.push("/opera/fangTXQ?id=" + res.data.retVal.id);
                } else this.$router.push("/opera/fangTXQ?id=" + res.data.retVal.id);
              }
            } else {
              this.bookInfo.token = res.data.retVal;
              this.msg(res.data.msg);
            }
          });
      }
    },
    components: {
      VuePickers,
      popSearch
    },
    computed: {},
    watch: {
      'datetime.endTime': {
        handler(curVal, oldVal) {
          this.getEverydayRate();

        },
        deep: true
      },
      'datetime.startTime': {
        handler(curVal, oldVal) {
          this.getEverydayRate();
        },
        deep: true
      }
    },
    filters: {
      dateMD(value) {
        return moment(value, "YYYY-MM-DD HH:mm:ss").format("MM/DD");
      },
      fdate(value) {
        return moment(value).format("YYYY-MM-DD");
      }
    }
  };
</script>

<style lang='less'>
  .opera-bookpage {
    background: #fff;

    .tabs {
      width: 100%;
      height: 1.1493rem;
      text-align: center;

      box-sizing: border-box;
      margin-bottom: 1px;
      margin-top: 3px;
      position: absolute;
      top: 1.066667rem;
      background: #f6f8f9;

      .tab {
        width: 20%;
        float: left;
        line-height: 1rem;
        height: 1rem;
        box-sizing: border-box;
        background: #fff;
        font-size: 0.33333333rem;

        span {
          line-height: 1rem;
          height: 1rem;
          display: inline-block;
        }

        &.active {
          border-bottom: 0.08rem solid #f69c2e;

          span {
          }
        }

        &:nth-last-of-type(1).active {
          border-right: 0;
        }

        &:nth-of-type(1).active {
          border-left: 0;
        }
      }
    }

    .content {
      .form {
        padding: 1.26666667rem 0.26666667rem 1.2rem 0.26666667rem;
        overflow: hidden;

        .info {
          box-sizing: border-box;
          margin: 0 auto;
          margin: 0.12rem auto;
          overflow: hidden;
          line-height: 0.88rem;
          /* float: left; */
          width: 9.5rem;

          label {
            box-sizing: border-box;
            padding-left: 0.13333333rem;
            float: left;
            text-align: left;
            width: 2.33333333rem;
            font-size: 0.33333333rem;
          }

          .info-input {
            float: right;
            width: 6.86666667rem;
            height: 0.88rem;
            border: 1px solid #e8e8e8;
            margin: 0 0.13333333rem;
            padding: 0 0.13333333rem;
            box-sizing: border-box;
            -webkit-appearance: none;
            outline: 0;

            &:focus {
              // border: 1px solid #e0b47b;
            }
          }

          .ratelist {
            .code {
              height: 0.96rem;
              line-height: 0.9867rem;
              text-align: center;
              border-bottom: 1px solid #d9d9d9;
            }
          }

          .search {
            float: left;
          }

          .parent {
            position: relative;
            margin: 0 0.13333333rem;
            padding: 0 0.13333333rem;
            float: left;
            width: 6.86666667rem;
            box-sizing: border-box;
            height: 0.88rem;
            background: #fff;
            border: 1px solid #e8e8e8;

            &.focus {
              border: 1px solid #e0b47b;

              .iconfont {
                color: #e0b47b;
              }
            }

            input {
              border: none;
              width: 100%;
              height: 0.82rem;
              box-sizing: border-box;
            }

            .iconfont {
              position: absolute;
              right: 0.26666667rem;
              top: 0px;
              /* transform: rotate(-90deg);*/
            }
          }

          .remark {
            width: 6.86666667rem;
            height: 1.6rem;
            border: 1px solid #e8e8e8;
            outline: none;
            box-sizing: border-box;
            display: block;
            float: left;
            padding: 7px;
            margin-left: 0.13333333rem;
            -webkit-appearance: none;
          }
        }

        p.tip {
          /* float: left; */
          width: 9.5rem;
          margin: 0 auto;
          color: #a6a6a6;
          /* margin: 0 0 0 2.53333333rem; */
          padding-left: 2.5rem;
          box-sizing: border-box
        }
      }
    }

    .foot {
      position: absolute;
      bottom: 0;
      width: 100%;
      height: 1.2rem;
      background-image: -webkit-linear-gradient(to left, #ff6e61, #f6a12a);
      background-image: -o-linear-gradient(to left, #ff6e61, #f6a12a);
      background-image: linear-gradient(to left, #ff6e61, #f6a12a);
      font-size: 0.42666667rem;
      color: #fff;
      text-align: center;
      z-index: 1000;

      .amount {
        line-height: 1.2rem;
        height: 1.2rem;
        float: left;
        width: 50%;
        box-sizing: border-box;

        .iconfont {
          margin-left: 0.08rem;
          /*-webkit-transform: translateY(-0.05333333rem) rotate(90deg);
  -moz-transform: translateY(-0.05333333rem) rotate(90deg);
  -ms-transform: translateY(-0.05333333rem) rotate(90deg);
  -o-transform: translateY(-0.05333333rem) rotate(90deg);
  transform: translateY(-0.05333333rem) rotate(90deg);*/
          display: inline-block;
          font-size: 0.26666667rem;
        }
      }

      .bookbtn {
        line-height: 1.2rem;
        height: 1.2rem;
        box-sizing: border-box;
        width: 50%;
        float: left;
      }
    }

    .mx_pop {
      background: transparent;
      z-index: 100 !important;

      .mx {
        box-shadow: 0px -0.08rem 0.4rem 0.10666667rem #e8e8e8;
        width: 10rem;
        box-sizing: border-box;
        padding: 0 0.4rem;
        margin-bottom: 1.2rem;
        background: #fff;

        .count {
          height: 1.22666667rem;
          border-bottom: 0.02666667rem solid #e8e8e8;

          span {
            font-size: 0.4rem;
            float: left;
            line-height: 1.22666667rem;
          }

          .icon {
            float: right;

            .iconfont {
              line-height: 1.22666667rem;
              font-size: 0.37333333rem;
            }
          }
        }

        .mxList {
          padding-top: 0.46666667rem;
          padding-bottom: 0.26666667rem;
          max-height: 8rem;
          min-height: 2rem;
          overflow: auto;

          li {
            height: 0.74666667rem;

            span {
              width: 33.3%;
              height: 0.74666667rem;
              line-height: 0.74666667rem;
              font-size: 0.33333333rem;
              padding-left: 0.2rem;
              box-sizing: border-box;
              float: left;
              text-align: left;
            }
          }
        }
      }
    }

    .pop {
      box-shadow: 0px -0.06666667rem 0.13333333rem 0.06666667rem #e8e8e8;

      .roomNums {
        .top {
          box-sizing: border-box;
          width: 10rem;
          height: 1.2rem;
          padding: 0.21333333rem 0.4rem 0.16rem;
          border-bottom: 0.02666667rem solid #ddd;

          .sure {
            margin-left: 0.02666667rem;
            float: left;
            height: 0.85333333rem;
            width: 1.86666667rem;
            border-radius: 0.10666667rem;
            font-size: 0.37333333rem;
            color: #333;
            background: #f4f4f4;
            border: 0.02666667rem solid #ddd;
          }

          .cancel {
            float: right;
            width: 0.85333333rem;
            height: 0.85333333rem;
            text-align: center;

            .iconfont {
              color: #333;
              line-height: 0.85333333rem;
              font-size: 0.37333333rem;
            }
          }
        }
      }

      .warp {
        height: 5.33333333rem;
        overflow: hidden;

        .rollWarp {
          box-sizing: border-box;
          height: 5.33333333rem;
          overflow: auto;

          .picker {
            .picker-slot {
              font-size: 0.4rem;

              .picker-item {
                &.picker-selected {
                  font-size: 0.64rem;
                }
              }
            }

            .picker-center-highlight {
              background: rgba(200, 200, 200, 0.3);
            }
          }
        }
      }
    }

    .parent {
      .cov-vue-date {
        width: 100%;

        .datepickbox {
          input {
            text-align: left !important;
            font-size: 0.32rem !important;
          }
        }
      }
    }

    .noShow {
      display: none;
    }

    .positionOne {
      transform: translate3d(0px, 0em, 0px);
    }

    .pickerBox {
      position: fixed;
      z-index: 1000;
      bottom: 0;
      margin-top: 0px;
    }

    .pickerBox .area_ctrl {
      position: fixed;
    }

    .slideInDown {
      bottom: 0rem;
      animation-name: none !important;
      animation: none !important;
    }
  }
</style>



// WEBPACK FOOTER //
// book.vue?6a12a6aa